import "./NhRobotHackResults.css";

type ResultValues = {
  rounds: number;
  minBet: string;
};

type NhRobotHackResultsProps = {
  gameTitle?: string;
  winPercent?: number;
  manualValues: ResultValues;
  autoValues: ResultValues;
  timeSlotText: string;
  refreshRemainingSec: number;
};

function formatGoldenHourDisplay(timeSlotText: string): string {
  const cleaned = timeSlotText.replace(/^>/, "").trim();
  const match = cleaned.match(/^(\d{1,2}:\d{2})\s*-\s*(\d{1,2}:\d{2})/);
  if (match) return `${match[1]} - ${match[2]}`;
  return cleaned.split("(")[0].trim().replace(/\s*–\s*/, " - ");
}

function formatRefreshCountdown(totalSeconds: number): string {
  const s = Math.max(0, Math.floor(totalSeconds));
  const mm = String(Math.floor(s / 60));
  const ss = String(s % 60).padStart(2, "0");
  return `${mm}:${ss}`;
}

export default function NhRobotHackResults({
  gameTitle = "SIÊU THỦ ACE 2",
  winPercent = 93,
  manualValues,
  autoValues,
  timeSlotText,
  refreshRemainingSec,
}: NhRobotHackResultsProps) {
  const goldenHour = formatGoldenHourDisplay(timeSlotText);
  const refreshText = formatRefreshCountdown(refreshRemainingSec);
  const title = gameTitle.trim().toUpperCase() || "SIÊU THỦ ACE 2";

  return (
    <div className="nh-robot-hack-results" onPointerDown={(e) => e.stopPropagation()}>
      <div className="nh-robot-hack-results__head">
        <span className="nh-robot-hack-results__chip" />
        AI-CORE // TRUYỀN DỮ LIỆU
      </div>
      <p className="nh-robot-hack-results__signal">{`>_TÍN HIỆU NỔ HŨ ${winPercent}%`}</p>
      <p className="nh-robot-hack-results__note">
        {`>_${title}: CHU KỲ ĐANG ĐẸP`}
        <br />
        VÀO MỒI THEO THÔNG SỐ
      </p>

      <div className="nh-robot-hack-results__box">
        <strong>Quay mồi</strong>
        <span>
          {manualValues.rounds} vòng - Mức cược {manualValues.minBet}
        </span>
      </div>
      <div className="nh-robot-hack-results__box">
        <strong>Quay Auto</strong>
        <span>
          {autoValues.rounds} vòng - Mức cược {autoValues.minBet}
        </span>
      </div>
      <div className="nh-robot-hack-results__box">
        <strong>KHUNG GIỜ VÀNG</strong>
        <span>{goldenHour}</span>
      </div>
      <div className="nh-robot-hack-results__box">
        <strong>Thời gian hiệu lực</strong>
        <span className="nh-robot-hack-results__timer">{refreshText}</span>
      </div>

      <p className="nh-robot-hack-results__tip">{">_GIỮ NHỊP CƯỢC ĐỀU, ĐỪNG TĂNG QUÁ TAY"}</p>
    </div>
  );
}
